import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { compose, branch, withProps } from 'recompose';
import classNames from 'classnames';

import styles from './timeplan.css';

function UnselectedDate({ date, isHolidayDate }) {
  return (
    <div key={date} className={`col-md-1 ${styles.sevencols}`}>
      <div>
        <b
          className={classNames({
            'text-danger': isHolidayDate,
          })}
          style={{ textTransform: 'capitalize' }}
        >
          {moment(date).format('ddd D/M')}
        </b>
      </div>
    </div>
  );
}

UnselectedDate.defaultProps = {
  isHolidayDate: false,
};

UnselectedDate.propTypes = {
  date: PropTypes.string.isRequired,
  isHolidayDate: PropTypes.bool,
};

export default compose(
  branch(({ holidayDates }) => !!holidayDates,
    withProps(({ holidayDates, date }) => ({
      isHolidayDate: holidayDates.includes(date)
    })),
  ),
)(UnselectedDate);
